export function openLink(url, target) {
	window.open(url, target, "noopener noreferrer")
}
